import React from "react";
import ReportPie from "./ReportPie";
import { IncomeReportData } from "../types";
import { Box, Grid, Typography, Paper } from "@mui/material";
import { formatCurrency } from "../../../utils/utils";

interface IncomeSummaryProps {
  data: IncomeReportData;
}

const IncomeSummary: React.FC<IncomeSummaryProps> = ({ data }) => {
  const incomeMetricData = [
    {
      value: data.summary.byBookingType.BUS.totalIncome,
      label: "Bus Income",
      color: "#2196f3",
    },
    {
      value: data.summary.byBookingType.LUGGAGE.totalIncome,
      label: "Luggage Income",
      color: "#ff9800",
    },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, height: "100%" }}>
            <Typography variant="subtitle2" color="text.secondary">
              Total Income
            </Typography>
            <Typography variant="h6" fontSize={16}>
              {formatCurrency(data.summary.totalIncome)}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary" mt={2}>
              Total Trips
            </Typography>
            <Typography variant="h6" fontSize={16}>
              {data.summary.totalTrips}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <ReportPie data={incomeMetricData} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IncomeSummary;
